import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/context/I18nContext";
import AuthLayout from "@/components/auth/AuthLayout";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function RequestAccess() {
  const t = useT();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [reason, setReason] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/beta/request-access", {
        name: name.trim(),
        email: email.trim(),
        organisation: organisation.trim() || null,
        reason: reason.trim() || null,
      });
      setDone(true);
      toast.success(t("auth.submitted"));
    } catch (e) {
      setErr(errMsg(e, t("errors.generic")));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      eyebrow={t("auth.requestAccess")}
      title={t("auth.requestTitle")}
      subtitle={t("auth.requestSub")}
      footer={<Link to="/login" data-testid="request-goto-login" className="text-sage-600 font-semibold hover:underline">← {t("auth.signIn")}</Link>}
    >
      {done ? (
        <div className="rounded-2xl bg-sage-100/60 border border-sage-200 p-6 text-ink-900" data-testid="request-success">
          <div className="font-heading text-lg mb-1">{t("auth.submitted")}</div>
          <p className="text-sm text-ink-500">{email}</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="request-form">
          <div>
            <Label htmlFor="ra-name">{t("common.name")}</Label>
            <Input id="ra-name" data-testid="request-name" required value={name} onChange={(e) => setName(e.target.value)}
              className="mt-1.5 h-11 rounded-xl bg-white" />
          </div>
          <div>
            <Label htmlFor="ra-email">{t("common.email")}</Label>
            <Input id="ra-email" data-testid="request-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 h-11 rounded-xl bg-white" />
          </div>
          <div>
            <Label htmlFor="ra-org">{t("auth.orgName")}</Label>
            <Input id="ra-org" data-testid="request-org" value={organisation} onChange={(e) => setOrganisation(e.target.value)}
              className="mt-1.5 h-11 rounded-xl bg-white" />
          </div>
          <div>
            <Label htmlFor="ra-reason">{t("auth.reason")}</Label>
            <Textarea id="ra-reason" data-testid="request-reason" rows={4} value={reason} onChange={(e) => setReason(e.target.value)}
              className="mt-1.5 rounded-xl bg-white" />
          </div>
          {err && <div data-testid="request-error" className="rounded-xl bg-rust-500/10 border border-rust-500/20 text-rust-600 text-sm px-3 py-2">{err}</div>}
          <Button type="submit" data-testid="request-submit" disabled={busy}
            className="w-full h-11 rounded-full bg-sage-500 hover:bg-sage-600 text-white font-medium">
            {busy ? t("common.loading") : t("common.submit")}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
